export const DESTROY_SESSION = "DESTROY_SESSION";
export const CREATE_SESSION = "CREATE_SESSION";
export const UPDATE_PREFERENCES = "UPDATE_PREFERENCES";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const BANNER_INFO = "BANNER_INFO";
